<div class="forum-mentions-list flex flex-column gap-4">
  <button
    *ngFor="let member of members; let index = index; trackBy: trackByMember"
    class="d-flex flex-row gap-12 forum-mentions-list__item"
    [class.forum-mentions-list__item--active]="index === activeIndex"
    (click)="selectMember.emit(member)"
  >
    <div class="forum-mentions-list__avatar">
      {{ member.first_name | initials: member.last_name }}
    </div>

    <div class="d-flex flex-column gap-4">
      <p class="text-label">
        {{ getDisplayName(member) }}
      </p>
      <p class="text-caption">
        {{ member.email }}
      </p>
    </div>
  </button>
</div>
